import React, { useState, useEffect, useRef } from 'react';

import TextInput from '../../../Form/TextInput';
import CurrencyInput from '../../../Form/CurrencyInput';
import Buttons from './Buttons';
import Select from '../../../Form/Select';

export default function EditableWithButtons({
  inputType,
  value,
  onSubmit,
  row,
  options,
}) {
  const [isEditable, setIsEditable] = useState(false);
  const [newValue, setNewValue] = useState(value);

  const inputRef = useRef();

  const inputProps = {
    onChange: (event) => setNewValue(event.target.value),
    value: newValue,
    reference: inputRef,
    options,
    setFieldValue: (_, val) => setNewValue(val),
  };

  let input = <TextInput {...inputProps} />;

  if (inputType === 'currency') {
    input = <CurrencyInput {...inputProps} />;
  } else if (inputType === 'select') {
    input = <Select {...inputProps} />;
  }

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  // Focus on input in edit mode
  useEffect(() => {
    if (isEditable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditable]);

  return (
    <div
      className="flex items-center gap-4"
      onClick={() => {
        if (!isEditable) {
          setIsEditable(true);
        }
      }}
    >
      {isEditable ? input : value}
      {isEditable && (
        <Buttons
          onSubmit={() => {
            if (!newValue.trim()) {
              return;
            }

            if (newValue === value) {
              setIsEditable(false);
              return;
            }

            onSubmit(row, newValue);
            setIsEditable(false);
          }}
          onCancel={() => setIsEditable(false)}
        />
      )}
    </div>
  );
}
